import { render, staticRenderFns } from "./General.vue?vue&type=template&id=63ced071&scoped=true&"
import script from "./General.vue?vue&type=script&lang=ts&"
export * from "./General.vue?vue&type=script&lang=ts&"
import style0 from "./General.vue?vue&type=style&index=0&id=63ced071&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ced071",
  null
  
)

export default component.exports